import React, { createElement, PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Redirect } from 'react-router-dom';
import reduxUtils from 'util/redux/index';
import { connect } from 'react-redux';
import { add as addEvent } from 'bianco.events';
import tracking from 'tracking/index';
import templates, { ERROR_NOT_FOUND, PRODUCT_DETAIL, PRODUCTS_LIST, PRODUCTS_OVERVIEW, TOPICS } from 'templates';
import getTemplateConfig from 'templates/config';
import { findRegionByCooperative } from 'util/misc/get-region';
import { linkToDashboardByUser } from 'util/misc/link-to-dashboard';
import linkToSiblingRegion from 'util/misc/link-to-sibling-region';
import t, { TransMD } from 'translations';
import { CHECKOUT } from 'constants/page-names';
import PROTECTED_PAGES from 'constants/protected-pages';

import { MISSING_ZIP_CODE, ORDER_PENDING, PRODUCT_NOT_IN_REGION } from 'constants/cart-error-types';

let isSplashScreenRemoved = false;


class PageContainer extends PureComponent {
    static propTypes = {
        activeRegion: PropTypes.object,
        component: PropTypes.object.isRequired,
        history: PropTypes.object.isRequired,
        isAuthenticated: PropTypes.bool.isRequired,
        isFirstRoute: PropTypes.bool.isRequired,
        location: PropTypes.object.isRequired,
        breadcrumbs: PropTypes.array.isRequired,
        login: PropTypes.func.isRequired,
        mustForceNotFound: PropTypes.bool.isRequired,
        match: PropTypes.object.isRequired,
        meta: PropTypes.object.isRequired,
        name: PropTypes.string,
        template: PropTypes.string.isRequired,
        pathname: PropTypes.string,
        deliveryStatus: PropTypes.string,
        flushProducts: PropTypes.func.isRequired,
        user: PropTypes.object.isRequired,
        requestedRegion: PropTypes.object,
        hasMissingMloginData: PropTypes.bool,
        wasCartFetched: PropTypes.bool.isRequired,
        routeLocation: PropTypes.object.isRequired,
        routeMeta: PropTypes.object.isRequired,
        setCooperative: PropTypes.func.isRequired,
        routerRegistry: PropTypes.object.isRequired,
        setLastRoute: PropTypes.func.isRequired,
        setRoute: PropTypes.func.isRequired,
        isCartFetching: PropTypes.bool.isRequired,
        isMainContentLoaded: PropTypes.bool.isRequired,
        setPageTitle: PropTypes.func.isRequired,
        clearCart: PropTypes.func.isRequired,
        openModal: PropTypes.func.isRequired,
        closeModal: PropTypes.func.isRequired,
        clearCartError: PropTypes.func.isRequired,
        requestOrder: PropTypes.func.isRequired,
        isNative: PropTypes.bool.isRequired,
        routeCooperative: PropTypes.string,
        setMainContentIsLoaded: PropTypes.func.isRequired,
        cartError: PropTypes.string,
        isLoaded: PropTypes.bool.isRequired,
        setForceNotFound: PropTypes.func.isRequired,
    };

    static defaultProps = {
        meta: {},
    };


    state = {
        redirectRouteName: null,
        redirectToLogin: false,
    };


    constructor(props) {
        super(props);
        this.setRoute(props);
    }

    componentWillMount() {
        if (!window.__is_not_found__) {
            this.props.setForceNotFound({ mustForceNotFound: false });
        }
        // reset the scroll position
        this.setBodyBusyState(this.props);
        this.props.setMainContentIsLoaded({ isLoaded: false });
    }

    componentDidMount() {
        const { template, meta, setLastRoute, routeLocation, routeMeta, isFirstRoute, setPageTitle } = this.props;

        // close the modals in case of url changes or browser back
        addEvent(window, 'hashchange popstate', () => this.props.closeModal());

        // set automatically the page title
        // but don't do it the product pages
        if (![PRODUCT_DETAIL, PRODUCTS_OVERVIEW, PRODUCTS_LIST, TOPICS].includes(template)) {
            setPageTitle({
                title: meta.title,
            });
        }

        if (!isFirstRoute) {
            setLastRoute({
                lastRoute: {
                    location: routeLocation,
                    meta: routeMeta,
                },
            });
        }

        if (
            !this.props.wasCartFetched &&
            !this.props.isNative &&
            !this.props.isCartFetching
        ) {
            this.props.requestOrder();
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.routeLocation.pathname !== window.location.pathname) {
            this.setRoute(nextProps);
        }

        if (this.props.isLoaded !== nextProps.isLoaded) {
            this.setBodyBusyState(nextProps);
        }

        // Handle redirects for non-public page names (routes)
        this.routeToLogin(nextProps);

        // prevent users browsing the checkout page without having an active region selected
        if (nextProps.name === CHECKOUT && !this.props.activeRegion) {
            // wait that the side panel eventually will be closed
            setTimeout(() => {
                this.showCartZipError(nextProps);
            }, 400);

            this.routeToDashboard(nextProps);
        }

        if (
            // this case checks whether the user has just set for the first time his/her region but he/she is in the wrong section of the site
        // see also https://jira.migros.net/browse/MCART-2524?focusedCommentId=1882306&page=com.atlassian.jira.plugin.system.issuetabpanels%3Acomment-tabpanel#comment-1882306
            (this.hasUserJustSetUserRegion(nextProps) && this.isUserInWrongRegionPages(nextProps)) ||
            // these other conditions match whether the user will change his/her region in runtime having it already set previously
            (
                nextProps.activeRegion && this.props.activeRegion &&
                nextProps.activeRegion.cooperative !== this.props.activeRegion.cooperative
            )) {
            this.routeToUsersProducts(nextProps);
        }

        if (nextProps.cartError) {
            this.showCartErrorModal(nextProps);
        }

        if (!this.props.isMainContentLoaded && nextProps.isMainContentLoaded) {
            this.onMainContentLoaded();
        }

        if (nextProps.isLoaded && !isSplashScreenRemoved) {
            window.__removeSplash__();
            isSplashScreenRemoved = true;
        }
    }

    onMainContentLoaded() {
        if (isSplashScreenRemoved || this.hasStartedWithARedirect()) {
            tracking.pageView(
                { ...this.props },
                this.props.breadcrumbs,
                this.props.user,
            );
        }

        window.scrollTo(0, 0);
    }

    /**
     * The initial page tracking event is weird and makes no sense but the script below does what they told me to do...
     * If there was an initial redirect via react we need to track it as pageView event otherwise don't track anything
     */
    hasStartedWithARedirect() {
        return !!(window.dataLayer && window.dataLayer.length && window.dataLayer.some(e => e.originalLocation && e.pnam !== document.location.pathname));
    }

    isUserInWrongRegionPages(nextProps) {
        return !!(nextProps.routeCooperative && nextProps.routeCooperative !== nextProps.activeRegion.cooperative);
    }

    hasUserJustSetUserRegion(nextProps) {
        return !!(!this.props.activeRegion && nextProps.activeRegion && nextProps.isLoaded);
    }

    setBodyBusyState(props) {
        document.body.setAttribute('aria-busy', !props.isLoaded);
        if (window.topconent) {
            // restore the focus on the top contents
            window.topconent.focus();
        }
    }


    setRoute({ match, history, location, meta, name, component }) {
        const { cooperative } = meta;

        this.props.setRoute({
            route: {
                match,
                history,
                location,
                meta,
                name: name || '',
                config: getTemplateConfig(component.props.template),
            },
        });

        if (cooperative !== this.props.routeCooperative) {
            this.props.setCooperative({
                cooperative,
            });
        }
    }

    routeToDashboard(nextProps) {
        this.setState({
            redirectRouteName: linkToDashboardByUser(nextProps.requestedRegion),
        });
    }

    routeToLogin({ name, isAuthenticated, hasMissingMloginData }) {
        switch (true) {
            case !isAuthenticated && PROTECTED_PAGES.includes(name):
            case hasMissingMloginData && name === CHECKOUT:
                this.setState({
                    redirectToLogin: true,
                });
                break;
            default:
                break;
        }
    }

    routeToUsersProducts(nextProps) {
        this.props.flushProducts();
        // trigger an hard page reload
        this.props.clearCart().then(() => {
            window.location.href = linkToSiblingRegion(nextProps.activeRegion, nextProps.routeCooperative, nextProps.pathname);
        });
    }

    showCartErrorModal(nextProps) {
        // clear the cart errors once displayed once
        this.props.clearCartError();
        switch (nextProps.cartError) {
            case MISSING_ZIP_CODE:
                return this.showCartZipError(nextProps);
            case PRODUCT_NOT_IN_REGION:
                return this.showCartRegionError(nextProps);
            case ORDER_PENDING:
                return this.showCartPendingOrderError(nextProps);
            default:
                return Promise.reject();
        }
    }

    showCartPendingOrderError() {
        return this.props.openModal({
            layout: 'alert',
            meta: {
                type: 'error',
                icon: {
                    size: 'large',
                    symbol: 'alert',
                },
                title: t('alert.pending_orders.title'),
                description: t('alert.pending_orders.description'),
            },
        });
    }


    showCartRegionError(nextProps) {
        const translationsData = {
            user_zip: nextProps.activeRegion.zip,
            user_region: findRegionByCooperative(nextProps.activeRegion.cooperative).region_display,
            products_region: findRegionByCooperative(nextProps.routeCooperative).region_display,
        };

        return this.props.openModal({
            layout: 'confirm',
            meta: {
                type: 'error',
                icon: {
                    size: 'large',
                    symbol: 'alert',
                },
                actions: [
                    {
                        name: t('modal.close'),
                        facet: 'secondary',
                        event: () => {
                            this.props.closeModal();
                        },
                    },
                    {
                        name: t('alert.product_not_in_region.change_region', translationsData),
                        event: () => {
                            this.props.closeModal();
                            this.routeToUsersProducts(nextProps);
                        },
                    },
                ],
                title: t('alert.product_not_in_region.title', translationsData),
                description: <TransMD path="alert.product_not_in_region.description" data={ translationsData }/>,
            },
        });
    }

    showCartZipError() {
        return this.props.openModal({
            layout: 'zip-form',
            meta: {
                descriptionPath: 'zip.notDefined',
            },
        });
    }

    render() {
        const { login, pathname, component, mustForceNotFound } = this.props;
        const { redirectToLogin, redirectRouteName } = this.state;

        if (redirectToLogin) {
            login(window.location.href);
            return null;
        }

        if (redirectRouteName && redirectRouteName !== pathname) {
            return <Redirect to={ redirectRouteName }/>;
        }

        if (mustForceNotFound) {
            return createElement(templates[ERROR_NOT_FOUND], this.props);
        }

        return component;
    }
}

export default connect(
    reduxUtils.mapStateToProps({
        routeLocation: 'router.location',
        routeMeta: 'router.meta',
        breadcrumbs: 'breadcrumbs.items',
        isFirstRoute: 'router.isFirstRoute',
        requestedRegion: 'region.requested',
        activeRegion: 'region.active',
        isCartFetching: 'cart.isFetching',
        wasCartFetched: 'cart.wasFetched',
        routerRegistry: 'router.registry',
        pathname: 'router.location.pathname',
        routeCooperative: 'router.cooperative',
        cartError: 'cart.cartError',
        user: 'user',
        isNative: 'viewport.isNative',
        isMainContentLoaded: 'main-content.isLoaded',
        isAuthenticated: 'user.isAuthenticated',
        hasMissingMloginData: 'user.has_missing_mlogin_data',
        isLoaded: 'main-content.isLoaded',
        lastRoute: 'router.lastRoute',
        mustForceNotFound: 'router.mustForceNotFound',
    }),
    reduxUtils.mapDispatchToProps({
        setRoute: 'router.set',
        flushProducts: 'products.flush',
        openModal: 'modal.open',
        closeModal: 'modal.close',
        setPageTitle: 'viewport.setTitle',
        clearCart: 'cart.clearCart',
        requestOrder: 'poll.requestOrder',
        clearCartError: 'cart.clearCartError',
        setLastRoute: 'router.setLastRoute',
        login: 'user.login',
        setForceNotFound: 'router.setForceNotFound',
        setMainContentIsLoaded: 'main-content.setIsLoaded',
        setCooperative: 'router.setCooperative',
    }),
)(PageContainer);



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/containers/page.js